import type { NutritionRowEstimate, ParsedVoiceMealDraft } from "./remote-meal-parser";

const knownCalories = (value: unknown) => typeof value === "number" && Number.isFinite(value) && value >= 0;

export function isNutritionRowComplete(row: NutritionRowEstimate): boolean {
  if (!knownCalories(row.calories)) return false;
  // Calories supplied for the whole dish override unknown component estimates.
  if (knownCalories(row.kcal100) || knownCalories(row.kcalPortion)) return true;
  return row.components.length > 0 && row.components.every(component => knownCalories(component.calories));
}

export function isMealNutritionComplete(draft: ParsedVoiceMealDraft): boolean {
  return !!draft.nutrition && draft.items.length === draft.nutrition.rows.length && draft.nutrition.rows.every(isNutritionRowComplete);
}

export function isNutritionRowSaveable(row: NutritionRowEstimate): boolean {
  return isNutritionRowComplete(row) || (row.components.length > 0 && row.components.every(component => knownCalories(component.calories) || component.ignored === true));
}

export function isMealNutritionSaveable(draft: ParsedVoiceMealDraft): boolean {
  return !!draft.nutrition && draft.items.length === draft.nutrition.rows.length && draft.nutrition.rows.every(isNutritionRowSaveable);
}
